
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pago",
      function () {
        return require("private-next-pages/pago/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pago"])
      });
    }
  